import { NotificationsRuntime } from '@/components/layout/NotificationsRuntime'
import { OfflineBanner } from '@/components/layout/OfflineBanner'
import { ThemeProvider } from '@/components/layout/ThemeProvider'
import { TopProgressBar } from '@/components/layout/TopProgressBar'
import { ErrorScreen, NotFoundScreen } from '@/components/shared/ErrorScreen'
import { ToastProvider } from '@/components/ui/toast'
import { queryClient } from '@/lib/query'
import { QueryClientProvider } from '@tanstack/react-query'
import { Outlet, createRootRoute } from '@tanstack/react-router'

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: ({ error, reset }) => (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <div className="min-h-dvh bg-muted text-foreground">
          <ErrorScreen error={error} reset={reset} />
        </div>
      </ThemeProvider>
    </QueryClientProvider>
  ),
  notFoundComponent: () => (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <div className="min-h-dvh bg-muted text-foreground">
          <NotFoundScreen />
        </div>
      </ThemeProvider>
    </QueryClientProvider>
  ),
})

function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <TopProgressBar />
          <OfflineBanner />
          <Outlet />
          <NotificationsRuntime />
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
